// GenericForm.js
import React from 'react';
import { Box, Grid, Button, Typography, InputLabel } from '@mui/material';
import RentalTextileLaundry from '../RentalTextileLaundry';
import { RENTAL_TEXTILE_LAUNDRY } from '../constants';

const GenericForm = ({ title, description, fields, onSubmit,onReset }) => {
  const [formValues, setFormValues] = React.useState(
    fields.reduce((acc, field) => ({ ...acc, [field.name]: field.defaultValue || '' }), {})
  );

  const handleSubmit = (event) => {
    event.preventDefault(); 
    onSubmit();
  };



  const handleReset = () => {
 
   onReset();
  };

  return (
    <Box sx={{  p:1 , mt: 0 }}>
       <Box textAlign={'left'} marginBottom={2} >
      <Typography fontSize={'16px'} fontFamily={'DiodrumRegular'} >{title}</Typography>
      <Typography fontSize={'16px'} fontFamily={'DiodrumSemiBold'} >{description}</Typography>
        </Box>
         <form>
        
          {fields.map((field, index) => (
            <Box display={'flex'} gap={'30px'} mt={0.5} pt={1} pb={1}>
                <Typography fontFamily={'DiodrumRegular'} width={field.width} textAlign='left'>{field.label}
                  <p className='sublabel-text'>{field.sublabel}</p>
                  </Typography>
                <Box display={'inline-flex'} gap={3.5}>
                {field.component}
                </Box>
            </Box>
              
          ))}
          <Grid item xs={12} mt={3}>
            <Button variant='outlined' color='warning' onClick={handleSubmit}  type="submit" sx={{borderRadius:'22px'}}>
              Calculate
            </Button>
            <Button variant='outlined' color='inherit' onClick={handleReset} sx={{ ml: 2,borderRadius:'22px' }}>
              Reset
            </Button>
          </Grid>
       
      </form>
    </Box>
  );
};

export default GenericForm;
